<template>
	<div>
		<dashboard-header></dashboard-header>

		<div id="content-frame">
			<div id="main-panel">
				<div v-if="$route.path == '/help'" class="container py-5">
					<!--<h2 class="mb-3">Documentation &amp; Support</h2>-->					
					<div class="py-5 bg-gradient-light-blue">
						<b-container>
							<b-row>
								<b-col class="text-center">
									<h1>
										How does {{siteText.siteName
										}} work?
									</h1>
									<p class="text-muted" v-if="!isAuthorized(roleNames.registered)">
										<!--<a @click.prevent="showLogin" href="#">Log in</a> or <a @click.prevent="showRegister" href="#">register</a> for an account to get started.-->
									</p>
									<p class="text-muted" v-else>
										<router-link to="/projects">Visit your projects dashboard</router-link> to get started.
									</p>
								</b-col>
							</b-row>
							<div v-html="siteText.homePageWorkLists"></div>
						</b-container>
					</div>				
					<div v-html="siteText.helpPageText"></div>

					<!--<p class="lead">
						Read the <strong><a :href="`/content/docs/${site.acronym}-User-Guide.pdf`" style="text-decoration:underline">{{site.acronym}} User Guide</a></strong>
						for a detailed walk-though on setting up and configuring {{site.acronym}} projects.
						This page will continue to expand as more guides and documentation are developed.
					</p>
					<p class="mb-1"><strong>For HAWQS data usage and paper citation, please reference the following:</strong></p>
					<p class="mb-0">HAWQS, 2020, "HAWQS System and Data to model the lower 48 conterminous U.S using the SWAT model",&nbsp;<a href="https://doi.org/10.18738/T8/XN3TE0" target="_blank" rel="noopener">doi.org/10.18738/T8/XN3TE0</a>, Texas Data Repository Dataverse, V1</p>

					<hr class="my-4" />

					<div v-if="tiers.length > 0">
						<h3 class="mt-4">{{site.acronym}} User Tiers</h3>
						<p>
							All users are placed in <b>Tier I</b> upon registration.
							To access a higher tier, <router-link to="/account">visit your account profile</router-link>
							and click the Tier Limitations tab.
						</p>
						<table class="table table-striped table-responsive">
							<thead>
								<tr>
									<th>Tier</th>
									<th>Max. Subbasins</th>
									<th>Max. HRUs</th>
									<th>Run Frequency</th>
									<th>Run Concurrently</th>
									<th>Queue Priority</th>
									<th>Max. Project Uploads</th>
									<th>Dataset Access</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(tier, i) in tiers" :key="i">
									<td>{{tier.name}}</td>
									<td>{{tier.subbasinLimit === 0 ? 'unlimited' : numberWithCommas(tier.subbasinLimit)}}</td>
									<td>{{tier.hruLimit === 0 ? 'unlimited' : numberWithCommas(tier.hruLimit)}}</td>
									<td>{{tier.taskLimit}}</td>
									<td>{{tier.concurrencyLimit === 0 ? 'unlimited' : numberWithCommas(tier.concurrencyLimit)}}</td>
									<td>{{tier.queuePriority}}</td>
									<td>{{tier.datasetUploadLimit | number(0)}}</td>
									<td>{{tier.datasets.join(', ')}}</td>
								</tr>
							</tbody>
						</table>
					</div>-->

					<div class="row">
						<div class="col-lg-6">
							<h3 class="mt-4">{{site.acronym}} Guides</h3>

							<ul>
								<li><a :href="`/content/docs/${site.acronym}-User-Guide.pdf`">{{site.acronym}} user guide</a></li>
								<li><a href="/content/docs/HUMID-FAQ.pdf">{{site.acronym}} frequently asked questions (FAQ)</a></li>
								<li><a :href="`/content/docs/${site.acronym}-Technical-Document.pdf`">{{site.acronym}} Technical Document</a></li>
								<li><a href="/content/docs/QSWAT-SWATCUP-Manual.pdf">QSWAT SWATCUP Manual</a></li>
								<!--<li><a href="/content/docs/HAWQS_to_SWAT_Editor.pdf">Using {{site.acronym}} projects in SWATeditor for further analysis</a></li>-->
							</ul>

							<h3 class="mt-4">{{site.acronym}} Data Documentation</h3>

							<ul class="ul-striped top-marg">
								<li><a href="/content/docs/HUMID-Appendix.pdf">{{site.acronym}} Appendix</a></li>
								<li><a href="/content/docs/HUMID-Input-Database-Citation.pdf">{{site.acronym}} Input Database Citation</a></li>
								<li><a href="/content/docs/HUMID-LandUse.pdf">Land Use Definition Table</a></li>
								<li><a href="/content/docs/HUMID-5kmGrid.pdf">SWAT 5km Grid model framework development</a></li>

								<!--<li>
									Calibration/Validation
									<ul>
										<li><a href="/content/docs/calibration/HAWQS-Calibration-Methodology.pdf">Methodology</a></li>
										<li><a href="/content/docs/calibration/HAWQS-Calibration-Locations.xlsx">Calibrated Locations and Values</a></li>
										<li><a href="/content/docs/calibration/SWAT-Calibration-Chap-33-from-SWAT-manual.pdf">SWAT Manual Chapter on Calibration</a></li>
										<li><a href="http://swat.tamu.edu/media/90102/azdezasp.pdf">SWAT: Model Use, Calibration, and Validation</a></li>
									</ul>
								</li>
								<li><a href="#" @click.prevent="show.climateChangeResources = true">Climate Change Data and Resources</a></li>
								<li><a href="#" @click.prevent="show.landuseTable = true" title="Table matching land use codes to a descriptive name." v-b-tooltip.hover>Land Use Definition Table</a></li>
								<li><a href="/content/docs/HAWQS-Point-Sources-Methodology.pdf">Point Sources Methodology</a></li>-->
							</ul>
						</div>

						<div class="col-lg-6">
							<h3 class="mt-4">SWAT Model Documentation</h3>

							<ul class="ul-striped top-marg">
								<li>
									<a href="http://swat.tamu.edu/documentation/2012-io/"
									   title="Full description of model inputs and outputs. The inputs are organized by topic and emphasis is given to differentiating required inputs from optional inputs." v-b-tooltip.hover>
										SWAT2012 Input/Output Documentation
									</a>
								</li>
								<li>
									SWAT Theoretical Documentation
									<ul>
										<li><a href="/content/docs/theory/Channel-Processes.pdf">Channel Processes</a></li>
										<li><a href="/content/docs/theory/Climate.pdf">Climate</a></li>
										<li><a href="/content/docs/theory/Erosion.pdf">Erosion</a></li>
										<li><a href="/content/docs/theory/Hydrology.pdf">Hydrology</a></li>
										<li><a href="/content/docs/theory/Management-Practices.pdf">Management Practices</a></li>
									</ul>
								</li>
								<li><a href="http://swat.tamu.edu/publications/">SWAT Publications</a></li>
								<li><a href="http://swat.tamu.edu/media/57020/j1-3-white.pdf">SWAT Check Documentation</a></li>
								<!--<li><a href="https://swat.tamu.edu/media/116265/differences_between_659_and_670.pdf">SWAT Revision Changes between 659 and 670</a></li>-->
							</ul>
						</div>
						<!--<div class="col-lg-6">
							<h3 class="mt-4">{{site.acronym}} Use-Cases</h3>

							<p>
								Walk through the {{site.acronym}} use-cases manual for setting up a new project and baseline scenario as well as four additional scenarios.
								<a href="/content/docs/use-cases/HAWQS-Use-Cases.pdf">Download the entire guide</a> or choose a scenario below:
							</p>

							<ul class="ul-striped top-marg">
								<li><a href="/content/docs/use-cases/HAWQS-Use-Cases-1-Baseline.pdf">Baseline Scenario</a></li>
								<li><a href="/content/docs/use-cases/HAWQS-Use-Cases-2-Climate-Sensitivity.pdf">Climate Sensitivity/Variability Scenario</a></li>
								<li><a href="/content/docs/use-cases/HAWQS-Use-Cases-3-Climate-Change.pdf">Climate Change Scenario</a></li>
								<li><a href="/content/docs/use-cases/HAWQS-Use-Cases-4-Land-Use-Change.pdf">Land Use Change Scenario</a> - <a href="/content/docs/use-cases/HAWQS-Use-Cases-4-Land-Use-Change-Material.zip">Data used in this scenario</a></li>
								<li><a href="/content/docs/use-cases/HAWQS-Use-Cases-5-Point-Source.pdf">Point Source Scenario</a> - <a href="/content/docs/use-cases/HAWQS-Use-Cases-5-Point-Source-Material.zip">Data used in this scenario</a></li>
							</ul>
						</div>-->
					</div>

					<!--<div class="row">
						

						<div class="col-lg-6">
							
						</div>
					</div>-->

					<!--<b-modal v-model="show.climateChangeResources" size="lg" title="Climate Change Data and Resources" scrollable hide-footer>
						<p>
							HAWQS incorporates five CMIP5 Models. The CMIP5 inputs are only available at the HUC 8 and 10 resolutions.
							<a href="/Content/docs/climate-change/Climate-Change-Model-Inputs.pdf" target="_blank">Read more about the climate change model inputs.</a>
						</p>

						<h4>LASSO plots</h4>

						<ul>
							<li><a href="/content/docs/climate-change/Region-1-LASSO-Scatterplots.pdf">Region 1 LASSO plots</a></li>
							<li><a href="/content/docs/climate-change/Region-2-LASSO-Scatterplots.pdf">Region 2 LASSO plots</a></li>
							<li><a href="/content/docs/climate-change/Region-3-LASSO-Scatterplots.pdf">Region 3 LASSO plots</a></li>
							<li><a href="/content/docs/climate-change/Region-4-LASSO-Scatterplots.pdf">Region 4 LASSO plots</a></li>
							<li><a href="/content/docs/climate-change/Region-5-LASSO-Scatterplots.pdf">Region 5 LASSO plots</a></li>
							<li><a href="/content/docs/climate-change/Region-6-LASSO-Scatterplots.pdf">Region 6 LASSO plots</a></li>
							<li><a href="/content/docs/climate-change/Region-7-LASSO-Scatterplots.pdf">Region 7 LASSO plots</a></li>
							<li><a href="/content/docs/climate-change/Region-8-LASSO-Scatterplots.pdf">Region 8 LASSO plots</a></li>
							<li><a href="/content/docs/climate-change/Region-9-LASSO-Scatterplots.pdf">Region 9 LASSO plots</a></li>
							<li><a href="/content/docs/climate-change/Region-10-LASSO-Scatterplots.pdf">Region 10 LASSO plots</a></li>
						</ul>

						<h4>Repository of reports</h4>

						<ul>
							<li><a href="http://www.globalchange.gov/browse/reports">U.S. National Climate Assessment</a></li>
							<li><a href="https://toolkit.climate.gov/">U.S. Climate Resilience Toolkit</a></li>
							<li><a href="https://www3.epa.gov/climatechange/science/">EPA Climate Change</a></li>
							<li><a href="https://www.epa.gov/climate-change-water-sector">EPA Climate Change and Water Resources</a></li>
						</ul>

						<h4>Data sources</h4>

						<ul>
							<li><a href="http://www.data.gov/climate/">Data.Gov/Climate</a></li>
							<li><a href="http://www.esrl.noaa.gov/psd/ipcc/cmip5/maps.html">NOAA Climate Change Web Portal</a></li>
							<li><a href="https://nex.nasa.gov/nex">NASA Earth Exchange</a></li>
							<li><a href="http://gdo-dcp.ucllnl.org/downscaled_cmip_projections/dcpInterface.html">CMIP3/CMIP5 Archive</a></li>
							<li>
								Gridded Data
								<ul>
									<li><a href="http://www.engr.scu.edu/~emaurer/gridded_obs/index_gridded_obs.html">Gridded Meteorological Data: 1949-2010</a></li>
									<li><a href="http://www.esrl.noaa.gov/psd/data/gridded/">ESRL PSD Gridded Climate Datasets</a></li>
								</ul>
							</li>
						</ul>
					</b-modal>

					<b-modal v-model="show.landuseTable" size="lg" title="Land Use Codes and Definitions" scrollable hide-footer>
						<b-alert variant="info" :show="cropCodes.length < 1">
							Data unavailable.
						</b-alert>
						<div v-if="cropCodes.length > 0">
							<table class="table">
								<tr v-for="(c, i) in cropCodes" :key="i">
									<th class="min">{{c.code}}</th>
									<td>{{c.name}}</td>
								</tr>
							</table>
						</div>
					</b-modal>

					<h3 class="mt-4">SWAT Run Time Guide</h3>

					<p>
						The table below gives an estimate of the time it takes to run SWAT in {{site.acronym}}. The times below are subject to fluctuation based on number of concurrent users and projects running on {{site.acronym}} at any given time.
					</p>

					<div class="table-responsive">
						<table class="table table-striped">
							<thead>
								<tr>
									<th></th>
									<th colspan="6">Time to run SWAT in {{site.acronym}} (minutes)</th>
								</tr>
								<tr>
									<th>#HRUs</th>
									<th>5 yr</th>
									<th>10 yr</th>
									<th>20 yr</th>
									<th>50 yr</th>
									<th>75 yr</th>
									<th>100 yr</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<th>100</th>
									<td>0.05</td>
									<td>0.06</td>
									<td>0.10</td>
									<td>0.19</td>
									<td>0.45</td>
									<td>0.43</td>
								</tr>
								<tr>
									<th>300</th>
									<td>0.10</td>
									<td>0.20</td>
									<td>0.36</td>
									<td>0.71</td>
									<td>1.00</td>
									<td>1.39</td>
								</tr>
								<tr>
									<th>1000</th>
									<td>0.43</td>
									<td>0.70</td>
									<td>1.21</td>
									<td>2.80</td>
									<td>4.12</td>
									<td>5.43</td>
								</tr>
								<tr>
									<th>2500</th>
									<td>1.52</td>
									<td>3.12</td>
									<td>3.33</td>
									<td>8.26</td>
									<td>11.71</td>
									<td>15.27</td>
								</tr>
								<tr>
									<th>5000</th>
									<td>2.20</td>
									<td>5.12</td>
									<td>4.85</td>
									<td>14.32</td>
									<td>20.40</td>
									<td>26.80</td>
								</tr>
								<tr>
									<th>10000</th>
									<td>4.43</td>
									<td>9.31</td>
									<td>16.94</td>
									<td>37.86</td>
									<td>56.41</td>
									<td>74.67</td>
								</tr>
								<tr>
									<th>15000</th>
									<td>11.68</td>
									<td>22.68</td>
									<td>43.19</td>
									<td>102.36</td>
									<td>152.75</td>
									<td>202.88</td>
								</tr>
								<tr>
									<th>20000</th>
									<td>22.53</td>
									<td>42.31</td>
									<td>81.94</td>
									<td>198.86</td>
									<td>296.89</td>
									<td>394.79</td>
								</tr>
								<tr>
									<th>30000</th>
									<td>55.03</td>
									<td>100.31</td>
									<td>196.94</td>
									<td>487.86</td>
									<td>728.55</td>
									<td>969.71</td>
								</tr>
								<tr>
									<th>50000</th>
									<td>163.23</td>
									<td>291.31</td>
									<td>576.94</td>
									<td>1449.86</td>
									<td>2165.36</td>
									<td>2883.97</td>
								</tr>
								<tr>
									<th>75000</th>
									<td>379.48</td>
									<td>670.68</td>
									<td>1333.19</td>
									<td>3372.36</td>
									<td>5036.68</td>
									<td>6710.06</td>
								</tr>
								<tr>
									<th>100000</th>
									<td>685.73</td>
									<td>1206.31</td>
									<td>2401.94</td>
									<td>6094.86</td>
									<td>9102.80</td>
									<td>12128.66</td>
								</tr>
							</tbody>
						</table>
					</div>-->
				</div>
				<router-view></router-view>
			</div>
		</div>

		<footer-data></footer-data>
	</div>
</template>

<script>
	import DashboardHeader from '@/components/DashboardHeader';
	import FooterData from '@/components/FooterData';

	export default {
		name: 'Help',
		components: {
			DashboardHeader, FooterData
		},
		data() {
			return {
				page: {
					errors: [],
					loadings: false
				},
				site: {
					acronym: 'HUMID',
					contactEmail: 'humid_nhp@wmail.iitm.ac.in'
				},
				show: {
					climateChangeResources: false,
					landuseTable: false
				},
				cropCodes: [],
				tiers: []
			}
		},
		async created() {
			await this.get();
		},
		methods: {
			async get() {
				this.page.errors = [];
				this.page.loading = true;

				try {
					const response = await this.$http.get(`datasets/cropcodes`, this.getTokenHeader());
					this.cropCodes = response.data;

					const response2 = await this.$http.get(`account/alltiers`, this.getTokenHeader());
					this.log(response2.data);
					this.tiers = response2.data;
				} catch (error) {
					if (this.isApiUnauthorized(error)) this.page.showLogin = true;
					else this.page.errors = this.logError(error);
				}

				this.page.loading = false;
			}
		}
	}
</script>
